exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3eec8ee0] .el-card__body{height:100%}[data-v-3eec8ee0] .el-icon-arrow-right{display:none}[data-v-3eec8ee0] .el-badge__content{top:10px}", ""]);

// exports
